import React from "react";
import styled from "@emotion/styled";
import { colors } from "src/theme";

const DividerContainerStyle = styled.div<{ gap?: number | string }>((props) => ({
  marginBlock: props.gap || 0,
  position: 'relative',
  width: '100%',
  height: 1,
}));

const DividerStyle = styled.div<{ dashed?: boolean; color?: string }>((props) => ({
  boxSizing: 'border-box',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: 1,
  background: props.dashed
    ? `repeating-linear-gradient(90deg, ${props.color} 0 5px, #0000 0 10px)`
    : props.color,
}));

interface Props {
  gap?: number | string;
  dashed?: boolean;
  color?: string;
  className?: string;
}

export const Divider: React.FC<Props> = ({ gap, dashed = true, color = colors.border3, className }) => (
  <DividerContainerStyle gap={gap} className={className} >
    <DividerStyle dashed={dashed} color={color} />
  </DividerContainerStyle>
);
